import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { valToPercent } from '../../../../../../helpers/value'
import TableSectorPerformance from '../../common/table'
import { KEY_DATA } from '../../constant'
import {
  selectCellData,
  selectCompareVal,
  selectDataTable,
  selectLoading,
  selectRowGroup,
} from '../../store/slice'

const TableRatioComparison = ({
  isDynamicReport,
  settingDynamic = {},
  year = '',
}) => {
  const locale = useSelector((state) => state.i18n.locale)
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn, ratioChecked = [] } =
    settingDynamic
  const compareVal = isDynamicReport ? compareValDyn : compareValStore

  const data = useSelector(selectDataTable(compareVal, 'ratio'))
  const isLoading = useSelector(selectLoading)
  const titleYear = I18n.t('companyAnalysis.industryAnalysis.FY', {
    year: year,
  })
  const headers = useMemo(() => {
    const result = [
      {
        title: titleYear,
        colId: 'typeGroup',
        thStyle: {
          justifyContent: 'flex-start',
        },
      },
      {
        title: '',
        colId: 'vsicId',
      },
      ratioChecked.includes(KEY_DATA.NET_REVENUE_GROWTH) || !isDynamicReport
        ? {
            title: 'companyAnalysis.industryAnalysis.NET_REVENUE_GROWTH',
            colId: KEY_DATA.NET_REVENUE_GROWTH,
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (val) => valToPercent(val, locale, false, false, 2, true),
            renderTh: (val) => val + ' (%)',
          }
        : undefined,
      ratioChecked.includes(KEY_DATA.NET_PROFIT_MARGIN) || !isDynamicReport
        ? {
            title: 'companyAnalysis.industryAnalysis.NET_PROFIT_MARGIN',
            colId: KEY_DATA.NET_PROFIT_MARGIN,
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (val) => valToPercent(val, locale, false, false, 2, true),
            renderTh: (val) => val + ' (%)',
          }
        : undefined,
      ratioChecked.includes(KEY_DATA.ROA) || !isDynamicReport
        ? {
            title: 'companyAnalysis.industryAnalysis.ROA',
            colId: KEY_DATA.ROA,
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (val) => valToPercent(val, locale, false, false, 2, true),
            renderTh: (val) => val + ' (%)',
          }
        : undefined,
      ratioChecked.includes(KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY) ||
      !isDynamicReport
        ? {
            title:
              'companyAnalysis.industryAnalysis.TOTAL_DEBT_TO_TOTAL_EQUITY',
            colId: KEY_DATA.TOTAL_DEBT_TO_TOTAL_EQUITY,
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (val) => valToPercent(val, locale, false, false, 2, true),
            renderTh: (val) => val + ' (%)',
          }
        : undefined,
      ratioChecked.includes(KEY_DATA.CURRENT_RATIO) || !isDynamicReport
        ? {
            title: 'companyAnalysis.industryAnalysis.CURRENT_RATIO',
            colId: KEY_DATA.CURRENT_RATIO,
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (val) => valToPercent(val, locale, false, false, 2, true),
            renderTh: (val) => val + ' (%)',
          }
        : undefined,
    ]
    return result.filter((item) => !!item)
  }, [ratioChecked, isDynamicReport])

  return (
    <div style={{ height: isDynamicReport ? 330 : 160 }}>
      <TableSectorPerformance
        dataTable={{
          typeComponent: 'ratio',
          data,
          headers,
          selectDataTable,
          selectCellData,
          selectRowGroup,
          isLoading,
          compareVal,
        }}
        isDynamicReport={isDynamicReport}
      />
    </div>
  )
}

export default TableRatioComparison
